// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__W3ryH","col":"styles_col__2c_Ur","fulfillmentStatus":"styles_fulfillmentStatus__vP1-f","emailCol":"styles_emailCol__1u0mB"};